import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import createColumns from './columns'
import moment from 'moment'
import _ from 'lodash'
import { parse } from 'querystring'
import 'moment-timer'
import './index.less'
import { message } from 'antd'

const { WizContainer, modelUtils } = framework_tool
const { WizSpin, WizTabs, WizDataTable, WizButton, WizModal, WizInput, WizEmpty, WizSelect } = component_tool
const { getPageData } = utils_tool
const getPageQuery = () => parse(window.location.href.split('?')[1])
const {
  id = 1,
  entityId = 0,
  remoteAuthId = 1,
  authState = 0,
  code = ''
} = getPageQuery()

class RemoteAssessment extends WizContainer {
  // 组件名 必传
  componentName = 'remoteAssessment'

  // 构造函数
  constructor(props) {
    super(props)
    this.state = {
      paper: [],
      dataSource: [],
      scores: {
        total: 0,
        detail: []
      },
      tabActiveKey: 0,
      isReady: false,
      isOver: false,
      timestamp: new Date().getTime()
    }
  }

  componentWillMount() {
    if (authState == 2) {
      this.setState({ isReady: true })
    }
  }

  componentDidMount() {
    // 加入防抖
    window.addEventListener('resize', _.debounce(() => {
      this.setState({ tableKey: new Date().getTime() })
    }, 500))
    this._getPaper()
  }

  _getPaper = () => {
    this.doAction({
      path: 'remoteAssessment/assessmentExamPaper',
      payload: {
        key: 'assessmentExamPaper',
        apiParams: {
          id,
          remoteAuthId,
          entityId,
          type: 1
        }
      },
    })
  }

  _changePaper = () => {
    this.doAction({
      path: 'remoteAssessment/changeAssessmentExamPaper',
      payload: {
        key: 'changeAssessmentExamPaper',
        apiParams: {
          id,
          remoteAuthId,
          entityId,
          type: 1
        }
      },
    })
  }

  _updateAssessmentState() {
    this.doAction({
      path: 'remoteAssessment/updateAssessmentState',
      payload: {
        key: 'updateAssessmentState',
        apiParams: {
          id,
          remoteAuthId,
          authState: 2
        }
      },
    })
  }

  _endAssessment = () => {
    this.doAction({
      path: 'remoteAssessment/updateAssessmentState',
      payload: {
        key: 'endAssessment',
        apiParams: {
          id,
          remoteAuthId,
          authState: 4
        }
      },
    })
  }

  _updateAssessmentPaper(params) {
    this.doAction({
      path: 'remoteAssessmentPaper/updateAssessmentPaper',
      payload: {
        key: 'updateAssessmentPaper',
        apiParams: { ...params }
      },
    })
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    paper: this._paperOnChange.bind(this),
    changePaper: this._changePaperOnChange.bind(this),
    assessmentState: this._assessmentStateOnChange.bind(this),
    end: this._endOnChange.bind(this),
  }

  _paperOnChange(nextProps, nextState) {
    if (nextProps.paper.success) {
      let paper = nextProps.paper.data || []
      let { dataSource, scores } = this._convertPaperData(paper)
      nextState.paper = paper
      nextState.dataSource = dataSource
      nextState.scores = scores
      return true
    } else {
      nextProps.paper.msg && message.info(nextProps.paper.msg)
    }
    return false
  }

  _changePaperOnChange(nextProps, nextState) {
    if (nextProps.changePaper.success) {
      let paper = nextProps.changePaper.data || []
      let { dataSource, scores } = this._convertPaperData(paper)
      nextState.paper = paper
      nextState.dataSource = dataSource
      nextState.scores = scores
      return true
    }
    return false
  }

  _convertPaperData = (paper = []) => {
    let data = []
    let scoreDetail = []
    let total = 0
    if (paper.length) {
      paper.map((item, index) => {
        let { examId, examModuleList, examName } = item
        let rows = []
        let examScore = 0
        let myScore = 0
        examModuleList && examModuleList.length && examModuleList.forEach(examModule => {
          let moduleSpan = 0
          let { moduleId, answers, moduleName } = examModule
          answers && answers.length && answers.forEach(answer => {
            let { authQuestionDetailScoreInfoList, questionName, target, requirements } = answer
            authQuestionDetailScoreInfoList && authQuestionDetailScoreInfoList.length && authQuestionDetailScoreInfoList.map((scoreItem, i) => {
              let rowSpans = {
                moduleSpan: 0,
                questionSpan: i === 0 ? authQuestionDetailScoreInfoList.length : 0
              }
              let row = { examId, examName, moduleId, moduleName, questionName, target, requirements, ...scoreItem, rowSpans }
              rows.push(row)
              moduleSpan += 1
              let { score, maxScore, minScore } = scoreItem
              if (maxScore && minScore >= 0 && maxScore >= minScore) {
                total += maxScore
                examScore += maxScore
              } else {
                total += 1
                examScore += 1
              }
              myScore += score || 0
            })
          })
          if (rows.length) {
            rows[rows.length - moduleSpan].rowSpans.moduleSpan = moduleSpan
          }
        })
        data.push({ ...item, rows })
        scoreDetail.push({ examId, score: examScore, myScore, index })
      })
    }
    return { dataSource: data, scores: { total, detail: scoreDetail } }
  }

  _assessmentStateOnChange(nextProps, nextState) {
    if (nextProps.assessmentState.code === 1) {
      nextState.isReady = true
    } else {
      nextProps.assessmentState.msg && message.info(nextProps.assessmentState.msg)
    }
    return true
  }

  _endOnChange(nextProps, nextState) {
    if (nextProps.end.code === 1) {
      nextState.isReady = false
      nextState.isOver = true
      message.info('请点击右上角“X”关闭检核窗口')
    }
    return true
  }

  _handleConform = (content, onOk, other) => {
    WizModal.confirm({
      content,
      onOk,
      ...other,
    })
  }

  // 更换考卷
  handleChangeStudentExamPaper = () => {
    this._handleConform(
      '更换考卷后原有考卷数据将被遗弃，请谨慎操作！',
      () => this._changePaper(),
      { okText: '更换考卷' }
    )
  }

  _updateAssessment = () => {
    message.destroy()
    if (this.state.isReady) {
      this._handleConform(
        '结束后将无法在进行考点得分修改，确认结束检核吗？',
        () => this._endAssessment()
      )
    } else {
      this._updateAssessmentState()
    }
  }

  _renderToolbar = () => {
    const { scores, isReady, isOver, tabActiveKey } = this.state
    let { detail } = scores
    let currentTotal = 0
    let myTotal = 0
    let currentScore = 0
    detail && detail.length && detail.forEach(item => {
      let { score, myScore, index } = item
      myTotal += myScore || 0
      if (index === tabActiveKey) {
        currentScore = myScore || 0
        currentTotal = score
      }
    })
    return (
      <div className='remote-table-toolbar'>
        <WizButton
          type='danger'
          onClick={this.handleChangeStudentExamPaper}
          disabled={isOver}
        >
          更换考卷
        </WizButton>
        <span>经销商编码：{code}</span>
        <span>当前一级目录得分：{currentScore}/{currentTotal}</span>
        <div>
          <span className='score'>
            总分: {myTotal}
          </span>
          <WizButton
            type={!isReady ? 'primary' : 'danger'}
            onClick={this._updateAssessment}
            disabled={isOver}
          >
            {!isReady ? '准备就绪' : '结束'}
          </WizButton>
        </div>
      </div>
    )
  }

  _tabOnChange = (activeKey) => {
    this.setState({ tabActiveKey: Number(activeKey) })
  }

  _renderTab = (examName) => {
    return (
      <div style={{ fontSize: 14 }}>
        <span>{examName}</span>
      </div>
    )
  }

  _scoreOnChange = (value, option, row) => {
    let { paper, dataSource, scores } = this.state
    paper.map((item, index) => {
      let { examId, examModuleList } = item
      if (examId === row.examId) {
        examModuleList && examModuleList.length && examModuleList.forEach(examModule => {
          let { moduleId, answers } = examModule
          if (moduleId === row.moduleId) {
            answers && answers.length && answers.forEach(answer => {
              let { authQuestionDetailScoreInfoList } = answer
              authQuestionDetailScoreInfoList && authQuestionDetailScoreInfoList.length && authQuestionDetailScoreInfoList.forEach(scoreItem => {
                let { authQuestionDetailId } = scoreItem
                if (authQuestionDetailId === row.authQuestionDetailId) {
                  scoreItem.score = value
                }
              })
            })
          }
        })
      }
      return item
    })
    dataSource.map((source, index) => {
      let { examId, rows } = source
      if (examId === row.examId) {
        rows && rows.length && rows.forEach(r => {
          if (r.authQuestionDetailId === row.authQuestionDetailId) {
            let { score } = r
            let difference = (value || 0) - (score || 0)
            let { detail } = scores
            scores.total += difference
            scores.detail = !scores.detail.length ? [] : scores.detail.map((s, i) => {
              if (s.examId === row.examId) {
                s.myScore += difference
              }
              return s
            })
            r.score = value || 0
          }
        })
      }
      return source
    })
    this.setState({
      paper,
      dataSource,
      scores,
      timestamp: new Date().getTime()
    }, () => {
      let data = this._convertUpdateData(row.examId)
      this._updateAssessmentPaper(data)
    })
  }

  _convertUpdateData = (examId) => {
    let data = {}
    let { paper } = this.state
    paper.forEach(item => {
      if (examId === item.examId) {
        let authQuestionDetailScores = []
        let { examModuleList, studentRemoteAuthDetailId } = item
        examModuleList && examModuleList.length && examModuleList.forEach(examModule => {
          let { answers } = examModule
          answers && answers.length && answers.forEach(answer => {
            let { authQuestionDetailScoreInfoList } = answer
            authQuestionDetailScoreInfoList && authQuestionDetailScoreInfoList.length && authQuestionDetailScoreInfoList.forEach(scoreItem => {
              let {
                id,
                score,
                authQuestionDetailId,
                studentAuthQuestionDetailAnswerId
              } = scoreItem
              authQuestionDetailScores.push({
                id,
                score,
                authQuestionDetailId,
                studentAuthQuestionDetailAnswerId,
                entityId,
                type: 1
              })
            })
          })
        })
        data = { studentRemoteAuthDetailId, entityId, authQuestionDetailScores }
      }
    })
    return data
  }

  _renderScore = (value, row, index) => {
    let options = []
    let { maxScore, minScore } = row
    if (maxScore && minScore >= 0 && maxScore >= minScore) {
      for (let i = minScore; i <= maxScore; i++) {
        options.push(<WizSelect.Option value={i}><div className='remote-assessment-score'>{i}</div></WizSelect.Option>)
      }
    } else {
      options.push(<WizSelect.Option value={0}><div className='remote-assessment-score'>{0}</div></WizSelect.Option>)
      options.push(<WizSelect.Option value={1}><div className='remote-assessment-score'>{1}</div></WizSelect.Option>)
    }
    let selectProps = {
      key: 'score_select_' + row.studentAuthQuestionDetailAnswerId,
      className: 'remote-assessment-select',
      size: 'small',
      disabled: !this.state.isReady,
      defaultValue: value,
      onChange: (value, option) => this._scoreOnChange(value, option, row)
    }
    let obj = {
      children: (
        <WizSelect {...selectProps} >
          {options}
        </WizSelect>
      ),
      props: {}
    }
    return obj
  }

  _dataTableProps = (dataItems, loading) => {
    return {
      key: 'table_' + this.state.timestamp,
      style: { marginTop: -16 },
      columns: createColumns(this),
      rowKey: 'authQuestionDetailId',
      bordered: true,
      loading,
      size: 'small',
      dataItems: getPageData({ records: dataItems }),
      // scroll: { y: window.innerHeight - 160 },
      tableLayout: 'fixed'
    }
  }

  _renderPaper = () => {
    const { remoteAssessmentLoading } = this.props
    const { dataSource } = this.state
    if (dataSource.length) {
      return (
        <WizTabs
          animated={false}
          defaultActiveKey='0'
          onChange={this._tabOnChange}
        >
          {
            dataSource.map((item, index) => (
              <WizTabs.TabPane key={index} tab={this._renderTab(item.examName)}>
                <WizDataTable {...this._dataTableProps(item.rows, remoteAssessmentLoading)} />
              </WizTabs.TabPane>
            ))
          }
        </WizTabs>
      )
    }
    return (
      <WizSpin spinning={remoteAssessmentLoading}>
        <WizEmpty style={{ marginTop: 30 }} />
      </WizSpin>
    )
  }

  render() {
    return (
      <div style={{ padding: 10, paddingBottom: 0, minWidth: 690 }}>
        {this._renderToolbar()}
        {this._renderPaper()}
      </div>
    )
  }
}

// 数据源
const mapStateToProps = (state, ownProps) => {
  const { remoteAssessment } = state
  const paper = modelUtils.getModelEntity(remoteAssessment, 'assessmentExamPaper')
  const changePaper = modelUtils.getModelEntity(remoteAssessment, 'changeAssessmentExamPaper')
  const assessmentState = modelUtils.getModelEntity(remoteAssessment, 'updateAssessmentState')
  const end = modelUtils.getModelEntity(remoteAssessment, 'endAssessment')
  const load = modelUtils.getLoadingState(state, 'remoteAssessment')
  return {
    paper,
    changePaper,
    assessmentState,
    end,
    ...load
  }
}

export default connect(mapStateToProps)(RemoteAssessment)
